<ng-container *ngIf="!isV2Route()">
<div class="app-container">
  <div class="mobile-wrapper">

    <!-- OFFLINE OVERLAY -->
    <div class="offline-screen" *ngIf="isOffline">
      <mat-icon class="offline-icon">wifi_off</mat-icon>
      <h2>No Connection</h2>
      <p>Please check your internet settings.</p>
      <button mat-flat-button color="primary" (click)="retryConnection()">
        <mat-icon>refresh</mat-icon> Retry
      </button>
    </div>

    <mat-progress-bar *ngIf="loadingService.isLoading()" mode="indeterminate" class="loading-progress" color="primary">
    </mat-progress-bar>
    <ng-container *ngIf="authService.user$ | async as currentUser">
      <!-- NEW MODERN HEADER -->
      <header class="modern-header">
        <!-- Row 1: Brand & Avatar -->
        <div class="header-top-row">
          <div class="header-brand" (click)="navigate(isLegacyRoute() ? '/legacy' : '')">
            <div class="brand-logo">
              <img src="kanithan-icon.png" alt="Kanithan Logo" class="header-logo-img">
            </div>
            <span class="brand-name">Kanithan</span>
          </div>

          <div class="header-right-v1">
            <button mat-flat-button class="switch-to-v2-btn" (click)="navigate('/v2/dashboard')" *ngIf="isLegacyRoute()">
              <mat-icon>rocket_launch</mat-icon>
              <span>Try 2.0</span>
            </button>
            <div class="header-avatar" (click)="navigate('profile')"
              [style.background-image]="currentUser.photoURL ? 'url(' + currentUser.photoURL + ')' : ''">
              {{ currentUser.photoURL ? '' : (currentUser.displayName ? currentUser.displayName.charAt(0) : 'U') }}
            </div>
          </div>
        </div>

        <!-- V2 PROMO BANNER (Only in V1 non-legacy context) -->
        <div class="v2-promo-banner" (click)="navigate('/v2/dashboard')" *ngIf="!isLegacyRoute()">
          <div class="promo-content">
            <span class="promo-badge">GURU AI 2.0</span>
            <span class="promo-text">Experience the modern way to track!</span>
          </div>
          <mat-icon class="promo-arrow">arrow_forward</mat-icon>
        </div>

        <!-- Row 2: Greeting & Badge -->
      </header>

      <!-- WELCOME BAR -->
      <div class="welcome-section">
        <div class="compact-greeting" *ngIf="userService.currentUserProfile$ | async as profile">
          Hi, {{ (profile.displayName || 'User').split(' ')[0] }}
        </div>

        <div class="active-badge compact-badge" *ngIf="familyService.currentFamily$ | async as family">
          <span class="dot"></span>
          {{ family.name }}
        </div>
      </div>

      <!-- Menu Drawer (Stay same for now, triggered by bottom nav) -->
      <div class="menu-overlay" *ngIf="showMenu" (click)="toggleMenu()"></div>
      <div class="side-menu" [class.open]="showMenu">
        <div class="menu-header">
          <button mat-icon-button (click)="toggleMenu()" class="close-menu-btn">
            <mat-icon>close</mat-icon>
          </button>

          <div class="menu-user-info">
            <div class="menu-avatar-large"
              [style.background-image]="currentUser.photoURL ? 'url(' + currentUser.photoURL + ')' : ''">
              {{ currentUser.photoURL ? '' : (currentUser.displayName ? currentUser.displayName.charAt(0) : 'U') }}
            </div>
            <span class="menu-name">{{ currentUser.displayName || 'User' }}</span>
            <span class="menu-email">{{ currentUser.email }}</span>
            <span class="version-tag-small" (click)="updateService.manualCheck()" class="version-link">v{{ version }} (Check
              Updates)</span>
          </div>
        </div>
        <nav>
          <!-- Overview -->
          <button mat-button (click)="navigate('')" 
            [class.active-nav]="router.url === '/' || router.url === '/legacy'">
            <mat-icon>dashboard</mat-icon> Dashboard
          </button>

          <!-- ... (omitted items for brevity, I should be careful not to delete them) ... -->
          <!-- Actually, replace_file_content requires exact match. I should target specific blocks. -->


          <!-- Habits -->
          <button mat-button (click)="navigate('habits')" routerLinkActive="active-nav">
            <mat-icon>check_circle_outline</mat-icon> Habit Tracker
          </button>

          <div class="menu-divider"></div>

          <!-- Tracking -->
          <button mat-button (click)="navigate('family')" routerLinkActive="active-nav">
            <mat-icon>home</mat-icon> Family Expenses
          </button>
          <button mat-button (click)="navigate('trips')" routerLinkActive="active-nav">
            <mat-icon>flight_takeoff</mat-icon> My Trips
          </button>

          <div class="menu-divider"></div>

          <!-- Analytics -->
          <button mat-button (click)="navigate('reports/family')" routerLinkActive="active-nav">
            <mat-icon>assessment</mat-icon> Family Reports
          </button>
          <button mat-button (click)="navigate('reports/trips')" routerLinkActive="active-nav">
            <mat-icon>analytics</mat-icon> Trip Reports
          </button>

          <div class="menu-divider"></div>





          <!-- Account & Support -->
          <button mat-button (click)="navigate('settings')" routerLinkActive="active-nav">
            <mat-icon>settings</mat-icon> Settings
          </button>

          <button mat-button (click)="navigate('feedback')" routerLinkActive="active-nav">
            <mat-icon>feedback</mat-icon> Feedback
          </button>

          <button mat-button (click)="navigate('admin')" routerLinkActive="active-nav"
            *ngIf="currentUser.email === 'josephvijayakumar.j@gmail.com' || currentUser.email === 'kanithan.official@gmail.com'">
            <mat-icon>admin_panel_settings</mat-icon> Admin
          </button>

          <!-- Install App Prompt -->
          <button mat-button color="accent" *ngIf="deferredPrompt" (click)="installApp()"
            class="update-available-chip">
            <mat-icon>downloading</mat-icon> Install App
          </button>

          <button mat-button color="warn" (click)="logout()" class="logout-btn">
            <mat-icon>exit_to_app</mat-icon> Logout
          </button>
        </nav>

      </div>

      <!-- NEW BOTTOM NAVIGATION -->
      <nav class="bottom-nav">
        <div class="nav-item" (click)="toggleMenu()">
          <mat-icon>menu</mat-icon>
          <span>Menu</span>
        </div>

        <div class="nav-item" [class.active]="router.url === '/family'" (click)="navigate('family')">
          <mat-icon>group</mat-icon>
          <span>Family</span>
        </div>

        <div class="nav-item" [class.active]="router.url.includes('/habits')" (click)="navigate('habits')">
          <mat-icon>check_circle</mat-icon>
          <span>Habits</span>
        </div>

        <div class="nav-item" [class.active]="router.url.includes('/trips')" (click)="navigate('trips')">
          <mat-icon>flight</mat-icon>
          <span>Trips</span>
        </div>

        <div class="nav-item" [class.active]="router.url === '/' || router.url === '/legacy'" (click)="navigate('')">
          <mat-icon>dashboard</mat-icon>
          <span>Home</span>
        </div>
      </nav>
    </ng-container>

    <!-- Route Content with padding for bottom nav -->
    <main class="content-area">
      <router-outlet></router-outlet>
    </main>

  </div>
</div>
</ng-container>

<ng-container *ngIf="isV2Route()">
  <router-outlet></router-outlet>
</ng-container>